<template>
  <div class="stemble-content">
    <slot />
  </div>
</template>
<style>
.stemble-content {
  h2 {
    @apply text-3xl md:text-4xl leading-tight mb-3;

    &:not(:first-child) {
      @apply mt-6;
    }
  }

  h3 {
    @apply text-xl font-medium leading-tight mb-3;

    &:not(:first-child) {
      @apply mt-6;
    }
  }

  blockquote {
    @apply relative border rounded-r border-blue-50 bg-gradient-to-br from-blue-50 to-white pl-5 pr-3 py-4 text-xl mt-4 mb-5;

    &:before {
      content: '';
      @apply absolute -left-px -top-px -bottom-px w-[5px] bg-blue-200;
    }
  }

  blockquote > *:last-child {
    @apply mb-0;
  }

  blockquote blockquote,
  blockquote blockquote blockquote blockquote {
    @apply from-white/70 to-blue-50/50;
  }

  blockquote blockquote blockquote {
    @apply from-blue-50 to-white;
  }

  p {
    @apply mb-2;
  }

  ul,
  ol {
    @apply pl-4 py-1 mb-3;
  }

  ul ul,
  ol ol,
  ul ol,
  ol ul {
    @apply pb-0 mb-0;
  }

  ul {
    @apply list-disc;
  }

  ol {
    @apply list-decimal;
  }

  li {
    @apply mb-2;
  }

  a {
    @apply text-blue-500 underline;
  }

  code {
    @apply bg-gray-200 text-gray-800 px-1 rounded-sm;
  }
}
</style>
<script setup lang="ts"></script>
